import React, { useState, useEffect, useRef, useCallback } from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'

import Pagination from '../components/paging'
import TransactionList from '../components/transactions/transactionList'
import { useLocation } from 'react-router'

const pageSize = 20

function Transactions() {
	let { state } = useLocation<any>()

	const [transactions, setTransactions] = useState<any[]>([])
	const [totalCount, setTotalCount] = useState(0)
	const [pageIndex, setPageIndex] = useState(state?.pageIndex || 0)
	const [pageDirection, setPageDirection] = useState<'desc' | 'asc'>(state?.pageDirection === 'desc' ? 'asc' : 'desc')


	const lastTransactionDate = useRef(state?.lastTransactionDate || new Date())

	useEffect(
		() => {
			let ref = firebase.firestore().collection('transactions')
				.orderBy('transactionDate', pageDirection)
				.startAfter(lastTransactionDate.current)

			const sub = ref
				.limit(pageSize)
				.onSnapshot(snap => {
					if (snap.size > 0) {
						lastTransactionDate.current = snap.docs[snap.size - 1].data().transactionDate.toDate()
					}

					const t = snap.docs.map(d => ({ ...d.data(), id: d.id }))
					setTransactions((pageDirection) === 'desc' ? t : t.reverse())
				})

			return sub
		},
		[pageDirection, pageIndex],
	)

	useEffect(
		() => {
			const sub = firebase.firestore().doc('metadata/transactions')
				.onSnapshot(snap => {
					setTotalCount(snap.data()?.count)
				})

			return sub
		},
		[],
	)

	const handlePageChange = useCallback(
		(ix) => {
			setPageIndex((prev: number) => {
				if (prev > ix) {
					lastTransactionDate.current = transactions[0].transactionDate.toDate()
					setPageDirection('asc')
				} else {
					lastTransactionDate.current = transactions[transactions.length - 1].transactionDate.toDate()
					setPageDirection('desc')
				}

				return ix
			})
		},
		[transactions],
	)

	if (transactions.length === 0) {
		return (
			<div className="flex flex-col container mt-4 mx-auto">
				<div className="mb-8 font-semibold text-lg text-gray-600 subpixel-antialiased">
					Transactions
				</div>
				<div className="bg-white shadow-xs p-4 text-sm text-gray-800 rounded">
					Nothing to see here
				</div>
			</div>
		)
	}

	return (
		<div className="flex flex-col container mt-4 mx-auto">
			<div className="mb-8 font-semibold text-lg text-gray-600 subpixel-antialiased">
				Transactions
			</div>
			<div className="self-end items-center mb-4">
				<Pagination onPageIndexChange={handlePageChange} pageIndex={pageIndex} pageSize={pageSize} totalCount={totalCount} />
			</div>
			<div className="bg-white shadow-xs rounded">
				<TransactionList state={{ lastTransactionDate: lastTransactionDate.current, pageIndex, pageDirection }} transactions={transactions} />
			</div>
			<div className="self-end items-center mt-4">
				<Pagination onPageIndexChange={handlePageChange} pageIndex={pageIndex} pageSize={pageSize} totalCount={totalCount} />
			</div>
		</div>
	)
}

export default Transactions
